import { render, staticRenderFns } from "./viewCouponInfo.vue?vue&type=template&id=c01d6912&scoped=true&"
import script from "./viewCouponInfo.vue?vue&type=script&lang=ts&"
export * from "./viewCouponInfo.vue?vue&type=script&lang=ts&"
import style0 from "./viewCouponInfo.vue?vue&type=style&index=0&id=c01d6912&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d6912",
  null
  
)

export default component.exports